import React from 'react'

// MsalAuthenticationTemplate renderiza `null` cuando la autenticación falla, lo que se
// ve como una pantalla en blanco sin ninguna pista del motivo. Este componente muestra
// el error real y permite limpiar el estado de MSAL, que es lo que desbloquea los casos
// de `interaction_in_progress` que queda colgado en sessionStorage.
//
// Sin i18n a propósito: los textos se descargan del locale API con un token, que es
// justo lo que no hay cuando esta pantalla se muestra.
export default function AuthError({ error }) {
    const retry = () => {
        sessionStorage.clear();
        window.location.replace(window.location.origin);
    };

    return (
        <div className="container">
            <p className="fs-5 text-center m-5">No fue posible completar el inicio de sesión.</p>
            {error?.errorCode &&
                <p className="text-center text-muted small">{error.errorCode}</p>
            }
            {error?.errorMessage &&
                <p className="text-center text-muted small">{error.errorMessage}</p>
            }
            <div className="d-flex justify-content-center m-5">
                <button type="button" className="btn btn-primary" onClick={retry}>
                    Volver a intentar
                </button>
            </div>
        </div>
    )
}
